/* eslint-disable no-undef */
// remove no-js flag
$('html').removeClass('no-js');

$(document).ready(() => {
  initSmallLayoutAnimations();
  initMapOptin();
  initAppForm();
  initAntispamField();
});

// FIX wrong 100vh in iOS and android jumps when the url bar hides
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const vh = window.innerHeight * 0.01;
// this is than used as var inside css/less
document.documentElement.style.setProperty('--vh', `${vh}px`);

function initAppForm() {
    let $checkboxes = $('.appform-checkbox');
    if ($checkboxes.length !== 0) {
        $checkboxes.change(function(){
            if($checkboxes.is(':checked')) {
                $checkboxes.removeAttr('required');
            } else {
                $checkboxes.attr('required', 'required');
            }
        });
    }

    const $referral = $('#refferal');
    const $onlineJobMarketField = $('#onlineJobMarketField');
    const $onlineJobMarket = $('#onlineJobMarket');

    if ($referral.length === 0 || $onlineJobMarketField.length === 0 || $onlineJobMarket.length === 0) return;

    const toggleOnlineJobMarket = () => {
        const isOnlineJobMarket = $referral.val() === 'Onlinestellenmarkt';

        $onlineJobMarketField.toggleClass('hidden', !isOnlineJobMarket);
        $onlineJobMarket.prop('required', isOnlineJobMarket);
        $onlineJobMarket.prop('disabled', !isOnlineJobMarket);
    };

    $referral.on('change', toggleOnlineJobMarket);
    toggleOnlineJobMarket();
}

function initMapOptin() {

    if (sessionStorage.getItem('omCookieConsentMaps') === '1') return optinAllowMaps();

    let $buttons = $('.accept-maps');
    if ($buttons.length === 0) return;
    let omCookie = omCookieUtility.getCookie('omCookieConsent');
    $buttons.click(function () {
        omCookieEnableCookieGrp(1);
        sessionStorage.setItem('omCookieConsentMaps', '1');
        optinAllowMaps();
    });
}

function optinAllowMaps() {
    let $mapOptins = $('.map-optin');
    if ($mapOptins.length === 0) return;
    $mapOptins.each(function() {
       $(this).addClass('allowed');
       let $iframe = $(this).find('iframe');
       $iframe.attr('src', $iframe.data('src'));
    });
}

function initAntispamField() {
  const $registrationForm = $('#registration-form');

  if ($registrationForm.length === 0) return;

  const $antispamField = $registrationForm.find('#antispam-field');

  if ($antispamField.length === 0) return;

  $registrationForm.on('submit', () => {
    $antispamField.val('JSNOSPAM');
  });
}
